import React, { useContext, useState } from "react";
import { useSelector } from "react-redux";

import { MultipleMenu, Logout, LogoutConfirmModal } from "../components/sidebar";
import { Section } from "../components/elements/Section";
import { Box } from "../components/elements";
import { DrawerContext } from "../context/Drawer";
import { sidebarData } from "../data/master/sidebar";
import { hasPermission } from "../utils/authUtils";

export function Sidebar() {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const { drawer } = useContext(DrawerContext);
  const permissions = useSelector((state) => state.user.permissions);
  const userType = useSelector((state) => state.user.user?.type);

  const onLogout = () => {
    setShowLogoutModal(true);
  };

  // navbar for normal admin
  const sidebarMenus = sidebarData?.navs[0].menu;
  // filter sidebar menus based on permissions
  const filteredSidebarMenus = sidebarMenus.filter((menu) => hasPermission(menu.permissions, permissions, "OR"));
  // navbar for superadmin
  const superAdminNav = sidebarData?.navs[1].menu;

  return (
    <Section as="aside" className={`mc-sidebar thin-scrolling ${drawer ? "active" : ""}`} style={styles.section}>
      <Box style={styles.menuBox}>
        {userType === "SUPER_ADMIN" ? (
          <MultipleMenu data={[{ title: "Super Admin", menu: superAdminNav }]} />
        ) : (
          <MultipleMenu data={[{ title: "", menu: filteredSidebarMenus }]} />
        )}
      </Box>

      <Box style={{ ...styles.logoutBox, left: drawer ? "0px" : "-270px" }}>
        <Logout onClick={onLogout} data={sidebarData?.button} />
      </Box>

      <LogoutConfirmModal open={showLogoutModal} onClose={() => setShowLogoutModal(false)} />
    </Section>
  );
}

const styles = {
  section: {
    display: "flex",
    flexDirection: "column",
    height: "calc(100vh - 75px)",
    overflow: "hidden",
    position: "relative",
    paddingBottom: 0,
  },
  menuBox: {
    flex: 1,
    overflowY: "auto",
  },
  logoutBox: {
    position: "fixed",
    bottom: 0,
    width: "270px",
    zIndex: 10,
    backgroundColor: "#FFFFFF",
    boxShadow: "0px -6px 6px -4px rgba(0, 0, 0, 0.35)",
  },
};
